import Phaser from 'phaser'
import EditorHandle from '../actors/editorHandle'

export default class GuideEditor {
  constructor (scene, editable) {
    this.scene = scene
    this.editable = editable

    this.handlers = []
    this.points = []
  }

  addPoint (x, y, start = false, noHeightBehind = false, noHeightInFront = false) {
    this.points.push({ x: x, y: y, start: start, noHeightBehind: noHeightBehind, noHeightInFront: noHeightInFront })
    var index = this.points.length - 1
    this.addHandler(x, y, (x, y) => { this.setPoint(index, x, y) }, () => { this.removePoint(index) })
  }

  insertPoint (x, y, start = false, noHeightBehind = false, noHeightInFront = false) {
    this.addPoint(x, y, start, noHeightBehind, noHeightInFront)
    this.points.sort((a, b) => { return a.x - b.x })
  }

  showHandlers () {
    for (var i = 0; i < this.handlers.length; i++) {
      this.handlers[i].show()
    }

    this.refreshHandlerPositions()
  }

  hideHandlers () {
    for (var i = 0; i < this.handlers.length; i++) {
      this.handlers[i].hide()
    }
  }

  addHandler (x, y, callback, deleteCallback) {
    var handler = new EditorHandle(this.scene, x, y, this, callback, 'editor_pos', deleteCallback)
    this.scene.add.existing(handler)
    this.handlers.push(handler)
  }

  refreshHandlerPositions () {
    for (var i = 0; i < this.points.length; i++) {
      this.handlers[i].image.x = this.points[i].x
      this.handlers[i].image.y = this.points[i].y
    }
  }

  setPoint (index, x, y) {
    this.points[index].x = x
    this.points[index].y = y
    this.editable.refresh()
    this.refreshHandlerPositions()
  }

  getPoint (index) {
    return { x: this.points[index].x, y: this.points[index].y, start: this.points[index].start }
  }

  getPointIndexAt (x) {
    for (var i = 0; i < this.points.length; i++) {
      if (this.points[i].x === x) {
        return i
      }
    }
    return 0
  }

  removePoint (index) {
    this.points.splice(index, 1)
    this.removeHandler(index)
    this.editable.refresh()
    this.refreshHandlerPositions()
  }

  removeHandler (index) {
    var removed = this.handlers.splice(index, 1)
    removed[0].delete()
  }

  delete () {
    for (var i = 0; i < this.handlers.length; i++) {
      this.handlers[i].delete()
    }
  }
}
